import React, { useEffect, useState } from 'react';
import PhoneIcon from 'src/assets/images/phone.svg';

import styles from './index.module.scss';

interface ContactPropsType {
    inputClass?: string;
    placeholder?: string;
    disabled?: boolean;
    value: null | string;
    isPhoneIcon?: boolean;
    mainContainerClass?: string;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ContactInput: React.FC<ContactPropsType> = (props) => {
    const {
        inputClass,
        mainContainerClass,
        placeholder = 'Enter number...',
        disabled = false,
        value,
        isPhoneIcon = false,
        onKeyDown,
        onChange,
    } = props;
    const [contactInput, setContactInput] = useState<string | null>();

    useEffect(() => {
        setContactInput(value)
    }, [value]);

    return (
        <div className={` ${styles.contact_container} ${mainContainerClass}`}>
            <div className={styles.input_container} style={{ backgroundColor: disabled ? '#FAFAFA' : 'transparent' }}>
                {isPhoneIcon && <img src={PhoneIcon} alt='phone_icon' className={styles.phone_icon} />}
                <div className={styles.span_container}>
                    <span>+91</span>
                </div>
                <div className={styles.input_div}>
                    <input
                        type='text'
                        inputMode='numeric'
                        className={` ${styles.input} ${inputClass}`}
                        placeholder={placeholder}
                        onChange={onChange}
                        onKeyDown={(e) => onKeyDown && onKeyDown(e)}
                        value={contactInput ?? undefined}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactInput;
